;
define("product_views_option_giftwrap.tpl", function(){});

